import { Registry } from "react-registry";

/**
 * @overview: desc
 *
 * @author: jesposito
 */

export interface IViewProviderProps {
	viewId: string;
	viewKey: string;
}

const ViewProvider: React.SFC<IViewProviderProps> = (props) => {
	return Registry.render({id: props.viewId, registry: "views"}, props);
};

export default ViewProvider;



// WEBPACK FOOTER //
// ./src/core/components/ViewProvider.tsx